export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZarizenikat';
export const NAME = 'KatZarizeni';
